import { useForm } from "@refinedev/react-hook-form";
import { RichTextEditor } from "@components/organisms/RichTextEditor";
import { Controller } from "react-hook-form";
import { Article, CreateArticleInput } from "types/articles";
import { useTranslate, useNavigation } from "@refinedev/core";
import { DefaultTemplate } from "@components/templates/default";
import { FaChevronLeft, FaFloppyDisk } from "react-icons/fa6";

export const ContentCreate = () => {
    const translate = useTranslate();
    const { goBack } = useNavigation();
    const {
        refineCore: { onFinish, formLoading },
        register,
        handleSubmit,
        control,
        formState: { errors },

    } = useForm<Article, any, CreateArticleInput>({
        refineCoreProps: {
            resource: "articles",
        },
    });

    const handleOnFinish = (values: CreateArticleInput) => {
        onFinish({
            ...values,
        });
    };

    return (
        <DefaultTemplate
            left={
                <button className="btn btn-ghost gap-2" onClick={goBack}>
                    <FaChevronLeft />
                    <span>{translate("common.buttons.back", "Volver")}</span>
                </button>
            }
        >
            <div className="card bg-base-100 shadow-xl max-w-4xl mx-auto my-8">
                <div className="card-body">
                    <h2 className="card-title text-2xl mb-6">{translate("articles.titles.create", "Crear Nuevo Artículo")}</h2>

                    <form onSubmit={handleSubmit(handleOnFinish)} className="flex flex-col gap-6">
                        <div className="form-control w-full">
                            <label className="label">
                                <span className="label-text font-bold text-lg">{translate("articles.fields.title", "Título")}</span>
                            </label>
                            <input
                                type="text"
                                placeholder={translate("articles.placeholders.title", "Escribe el título...")}
                                className={`input input-bordered w-full ${errors.title ? "input-error" : ""}`}
                                {...register("title", { required: true })}
                            />
                            {errors.title && <span className="text-error text-sm mt-1">Este campo es requerido</span>}
                        </div>

                        <div className="flex flex-col md:flex-row gap-4">
                            <div className="form-control flex-1">
                                <label className="label">
                                    <span className="label-text font-bold text-lg">{translate("articles.fields.landing_image", "Imagen de Portada (URL)")}</span>
                                </label>
                                <input
                                    type="text"
                                    placeholder="https://images.unsplash.com/..."
                                    className="input input-bordered"
                                    {...register("landing_image")}
                                />
                            </div>
                        </div>

                        <div className="form-control w-full">
                            <label className="label">
                                <span className="label-text font-bold">{translate("articles.fields.tags", "Etiquetas")}</span>
                            </label>
                            <Controller
                                control={control}
                                name="tags"
                                defaultValue={[]}
                                render={({ field }) => (
                                    <input
                                        type="text"
                                        placeholder="salud, bienestar, nutrición"
                                        className="input input-bordered w-full"
                                        value={field.value?.join(", ")}
                                        onChange={(e) => {
                                            const tags = e.target.value.split(",").map(t => t.trim()).filter(t => t !== "");
                                            field.onChange(tags);
                                        }}
                                    />
                                )}
                            />
                        </div>

                        <div className="form-control w-full">
                            <label className="label">
                                <span className="label-text font-bold text-lg">{translate("articles.fields.content", "Contenido")}</span>
                            </label>
                            <Controller
                                control={control}
                                name="content"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <RichTextEditor
                                        content={field.value}
                                        onChange={field.onChange}
                                        placeholder="Escribe aquí..."
                                    />
                                )}
                            />
                            {errors.content && <span className="text-error text-sm mt-1">El contenido es requerido</span>}
                        </div>

                        <div className="card-actions justify-end mt-6">
                            <button
                                type="submit"
                                className={`btn btn-primary btn-wide ${formLoading ? 'loading' : ''}`}
                                disabled={formLoading}
                            >
                                <FaFloppyDisk className="mr-2" />
                                {translate("common.buttons.save", "Guardar y Publicar")}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </DefaultTemplate>
    );
};
